export enum DisclosureRegimeEnum {
  ONE = 'ONE',
  TWO = 'TWO',
  THREE = 'THREE',
  FOUR = 'FOUR',
  FIVE = 'FIVE',
  SIX = 'SIX',
  SEVEN = 'SEVEN',
  EIGHT = 'EIGHT',
  NINE = 'NINE',
  TEN = 'TEN',
  ELEVEN = 'ELEVEN',
  TWELVE = 'TWELVE',
  THIRTEEN = 'THIRTEEN',
  FOURTEEN = 'FOURTEEN',
  FIFTEEN = 'FIFTEEN',
  SIXTEEN = 'SIXTEEN',
  SEVENTEEN = 'SEVENTEEN',
  EIGHTEEN = 'EIGHTEEN',
  NINETEEN = 'NINETEEN',
  TWENTY = 'TWENTY',
  TWENTY_ONE = 'TWENTY_ONE',
  TWENTY_TWO = 'TWENTY_TWO',
  TWENTY_THREE = 'TWENTY_THREE',
  TWENTY_FOUR = 'TWENTY_FOUR',
  TWENTY_FIVE = 'TWENTY_FIVE',
  TWENTY_SIX = 'TWENTY_SIX',
  TWENTY_SEVEN = 'TWENTY_SEVEN',
  TWENTY_EIGHT = 'TWENTY_EIGHT',
  TWENTY_NINE = 'TWENTY_NINE',
  THIRTY = 'THIRTY',
  THIRTY_ONE = 'THIRTY_ONE',
  THIRTY_TWO = 'THIRTY_TWO',
  THIRTY_THREE = 'THIRTY_THREE',
  THIRTY_FOUR = 'THIRTY_FOUR',
  THIRTY_FIVE = 'THIRTY_FIVE',
}
